import { httpRequest } from "../../http";
import {TraceSerializer} from "@models/serializers/traceSerializer.ts";
import {Trace} from "@models/trace.model.ts";

export class CommandGetTraceList {
    async run(httpMethod: string, status: string, search: string, employeeId: any, limit: any, offset: any) {

        const url = new URL(`${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/traces/`);

        url.searchParams.set("http_method", httpMethod);
        url.searchParams.set("status", status);
        url.searchParams.set("limit", limit);
        url.searchParams.set("offset", offset);

        if (search.length > 0)
            url.searchParams.set("search", search);

        if (employeeId !== -1)
            url.searchParams.set("employee", employeeId);

        const finalUrl = url.toString();

        try {
            const response = await httpRequest<any>(finalUrl, { method: "GET" });
            return this.deserialize(response);
            
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any) : Trace[] {
        const serializer = new TraceSerializer();
        return serializer.deserializeList(data);
    }

}
